// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Header_container__ogplU {
  width: 100%;
  background-color: #f5fafa;
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 2rem 0 0 0;
}

.Header_headerContent__h\\+Fwg {
  width: 95%;
  display: flex;
  justify-content: space-between;
}

.Header_search__urVX4 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 349px;
  height: 44px;
  padding: 0px 12px;
  border-radius: 8px;
  background-color: white;
}

.Header_search__urVX4 input {
  width: 100%;
  height: 32px;
  background-color: white;
  border: none;
  font-size: 13px;
  line-height: 20px;
  letter-spacing: 0.5%;

  &&:focus {
    outline: none;
  }
}

.Header_headerIcons__d-YrE {
  display: flex;
  gap: 16px;
}

.Header_headerIcons__d-YrE span {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 44px;
  height: 44px;
  background-color: white;
  border-radius: 8px;
  cursor: pointer;
}

.Header_flagContainer__LgONZ {
  position: relative;
  display: flex;
  width: 44px;
  height: 44px;
  background-color: white;
  border-radius: 8px;
  justify-content: center;
  align-items: center;
}

.Header_flagContainer__LgONZ img {
  cursor: pointer;
  width: 28px;
  height: 20px;
}
`, "",{"version":3,"sources":["webpack://./src/components/header/Header.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,yBAAyB;EACzB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,oBAAoB;;EAEpB;IACE,aAAa;EACf;AACF;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;AACd","sourcesContent":[".container {\n  width: 100%;\n  background-color: #f5fafa;\n  height: 80px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 2rem 0 0 0;\n}\n\n.headerContent {\n  width: 95%;\n  display: flex;\n  justify-content: space-between;\n}\n\n.search {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 349px;\n  height: 44px;\n  padding: 0px 12px;\n  border-radius: 8px;\n  background-color: white;\n}\n\n.search input {\n  width: 100%;\n  height: 32px;\n  background-color: white;\n  border: none;\n  font-size: 13px;\n  line-height: 20px;\n  letter-spacing: 0.5%;\n\n  &&:focus {\n    outline: none;\n  }\n}\n\n.headerIcons {\n  display: flex;\n  gap: 16px;\n}\n\n.headerIcons span {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 44px;\n  height: 44px;\n  background-color: white;\n  border-radius: 8px;\n  cursor: pointer;\n}\n\n.flagContainer {\n  position: relative;\n  display: flex;\n  width: 44px;\n  height: 44px;\n  background-color: white;\n  border-radius: 8px;\n  justify-content: center;\n  align-items: center;\n}\n\n.flagContainer img {\n  cursor: pointer;\n  width: 28px;\n  height: 20px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Header_container__ogplU`,
	"headerContent": `Header_headerContent__h+Fwg`,
	"search": `Header_search__urVX4`,
	"headerIcons": `Header_headerIcons__d-YrE`,
	"flagContainer": `Header_flagContainer__LgONZ`
};
export default ___CSS_LOADER_EXPORT___;
